import { isObjectEmpty } from '../../../utility/helpers';
import { isRichTextEditorEmpty } from '../../../utility/validation';

export const AUTO_CHANGE_QUESTION_DELAY = 500;

export const prepareSurveySteps = (review, isQuestionnaire) => {
  if (isObjectEmpty(review)) {
    return [];
  }

  return [
    ...(isRichTextEditorEmpty(review.visible_description) ||
    (isQuestionnaire && isRichTextEditorEmpty(review.description))
      ? [
          {
            id: 'review_description',
          },
        ]
      : []),
    ...review.questions.map(question => ({
      id: question.id,
    })),
    ...(review.hasAdditionalFeedback
      ? [
          {
            id: 'survey_comments',
          },
        ]
      : []),
  ];
};

export const setPageHeight = () => {
  document.getElementById(
    'fill-survey-page'
  ).style.height = `${window.innerHeight}px`;
};
